"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
const kanbans_1 = require("../gql/kanbans");
const repositories_1 = require("../repositories");
const gql_1 = require("../gql");
class KanbanColumn extends BaseModel_1.default {
    constructor(props) {
        super(props);
        this.tasks = repositories_1.TaskRepository.fromArray((props === null || props === void 0 ? void 0 : props.tasks) || []);
    }
    defaults() {
        return {
            uuid: '',
            title: '',
            position: null,
            isArchive: false,
            tasks: [],
        };
    }
    create() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate(kanbans_1.createKanbanColumnMutation, yield this.prepareVariables());
        });
    }
    update() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate(kanbans_1.updateKanbanColumnMutation, yield this.prepareVariables());
        });
    }
    updateTasks() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate(gql_1.updateTasksMutation, {
                tasks: yield Promise.all(this.tasks.map((u) => tslib_1.__awaiter(this, void 0, void 0, function* () { return u.getUpdateVariables(); }))),
            });
        });
    }
    delete() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { uuid } = this;
            return this.mutate(kanbans_1.deleteKanbanColumnMutation, { uuid });
        });
    }
    prepareVariables() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const kanbanColumn = yield this.getUpdateVariables();
            return {
                kanbanColumn,
            };
        });
    }
}
exports.default = KanbanColumn;
//# sourceMappingURL=KanbanColumn.js.map